import { __rest } from "tslib";
const dateTimeFormatCache = {};
/**
 * Creates and caches Intl.DateTimeFormat instances.
 * @hidden
 * @param options
 */
export const getIntlDateTimeFormat = (options = {}) => {
    const key = JSON.stringify(options);
    const cachedFormat = dateTimeFormatCache[key];
    if (cachedFormat) {
        return cachedFormat;
    }
    const { languageTag } = options, opts = __rest(options, ["languageTag"]);
    const format = Intl.DateTimeFormat(languageTag, Object.assign({}, opts));
    dateTimeFormatCache[key] = format;
    return format;
};
//# sourceMappingURL=get-intl-date-time-format.js.map